import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";

export default function ({ children,BaseUrl }) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
  };
  const [data, setdata] = useState({});
  // load user information
  // check if is Authorized or not , check is Authtenticated or not
  // while loadin =>show a loadin
  //  if user is Authenticated and isAuthorized =>render app =childern
  useEffect(() => {
    axios
      .get(`${BaseUrl}/user/userCurent`, { headers: headers })
      .then((res) => {
        setdata(res.data.user);
        
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  let isauthorized = false;
  let isLoading = false;
  if (data.userStatus && data) {
    isauthorized = true;
    isLoading = false;
    return children;
  } else {
    isauthorized = false;

    return null
  }
}
